import { createSlice } from "@reduxjs/toolkit";

export const PopUpSlice = createSlice({
    name:'popUps',
    initialState:{
        loadingPopUp:false,
        verifyUserPopUp:{
            toggle:false,
            data:{},
            response:{}
        },
        ImgPopUp:{
            toggle:false,
            data:"",
            url:""
        },
    },

    reducers:{
        toggleLoading :(state,action)=>{
           //console.log(action)
            state.loadingPopUp = action.payload 
        },
        toggleVerifyUser :(state,action)=>{
           //console.log(action)
            state.verifyUserPopUp.toggle = action.payload 
        },
        toggleImgPopUp :(state,action)=>{
           //console.log(action)
            state.ImgPopUp.toggle = action.payload 
        },
        addImgPopUp :(state,action)=>{
           //console.log(action)
            state.ImgPopUp.data = action.payload 
        },
        addVerifyUserData :(state,action)=>{
           //console.log(action)
            state.verifyUserPopUp.data = action.payload 
        },
        addVerifyUserResponse :(state,action)=>{
           //console.log(action)
            state.verifyUserPopUp.data = action.payload 
        }
    }
})

export const {toggleLoading,toggleVerifyUser,addVerifyUserData,toggleImgPopUp,addImgPopUp} = PopUpSlice.actions

export default PopUpSlice.reducer